import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function TrashIcon(props: ACIconProps) {
  return <ACIconWrapper {...props} component={IconSvg} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.75 5.5C10.0596 5.5 9.5 6.05964 9.5 6.75V7H13.5V6.75C13.5 6.05964 12.9404 5.5 12.25 5.5H10.75ZM15 7V6.75C15 5.23122 13.7688 4 12.25 4H10.75C9.23122 4 8 5.23122 8 6.75V7H5.75H4.75C4.33579 7 4 7.33579 4 7.75C4 8.16421 4.33579 8.5 4.75 8.5H5.06239L5.84397 17.4883C5.96754 18.9094 7.15721 20 8.58363 20H14.4164C15.8428 20 17.0325 18.9094 17.156 17.4883L17.156 17.4882L17.9376 8.5H18.25C18.6642 8.5 19 8.16421 19 7.75C19 7.33579 18.6642 7 18.25 7H17.25H15ZM16.4319 8.5H14.25H8.75H6.56805L7.33833 17.3583C7.3945 18.0042 7.93523 18.5 8.58363 18.5H14.4164C15.0648 18.5 15.6055 18.0042 15.6616 17.3584L15.6616 17.3583L16.4319 8.5ZM9.75 10C10.1642 10 10.5 10.3358 10.5 10.75V16.25C10.5 16.6642 10.1642 17 9.75 17C9.33579 17 9 16.6642 9 16.25V10.75C9 10.3358 9.33579 10 9.75 10ZM14 10.75C14 10.3358 13.6642 10 13.25 10C12.8358 10 12.5 10.3358 12.5 10.75V16.25C12.5 16.6642 12.8358 17 13.25 17C13.6642 17 14 16.6642 14 16.25V10.75Z"
        fill="currentColor"
      />
    </svg>
  );
};
